import { wrap } from '@archetype-themes/utils/utils'

class AtRte extends HTMLElement {
  connectedCallback () {
    this.wrapTablesWithScrollable()
    this.wrapVideoEmbeds()
    this.removeAnimatedUnderline()
    this.addColspanToTh()
  }

  wrapTablesWithScrollable () {
    this.querySelectorAll('table').forEach(table => {
      var wrapWith = document.createElement('div')
      wrapWith.classList.add('table-wrapper')
      wrap(table, wrapWith)
    })
  }

  wrapVideoEmbeds () {
    this.querySelectorAll(
      'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'
    ).forEach(iframe => {
      this.wrapVideo(iframe)
    })
  }

  wrapVideo (iframe) {
    iframe.src = iframe.src // Reset src to fix Chrome back navigation issue
    var wrapWith = document.createElement('div')
    wrapWith.classList.add('video-wrapper')
    wrap(iframe, wrapWith)
  }

  removeAnimatedUnderline () {
    this.querySelectorAll('a img').forEach(img => {
      img.parentNode.classList.add('rte__image')
    })
  }

  addColspanToTh () {
    this.querySelectorAll('tr').forEach(tr => {
      if (!tr.querySelector('td')) {
        // Check if tr has no td elements
        let th = tr.querySelector('th')
        if (th) {
          th.setAttribute('colspan', '2')
        }
      }
    })
  }
}

customElements.define('at-rte', AtRte)
